import React from 'react'

import AnimatedCursor from "react-animated-cursor"

function AnimCursor() {
  return (
    <AnimatedCursor 
    innerSize={12}
    outerSize={18}
    color='255, 51, 51'
    outerAlpha={0.3}
    innerScale={0.7}
    outerScale={5}
    trailingSpeed={10}
    // hasBlendMode={true}
    outerStyle={{
        border: '1px solid #fff',
        // mixBlendMode: 'exclusion'
      }}
    
      

    clickables={[
        'a',
        'input[type="text"]',
        'input[type="email"]',
        'input[type="number"]',
        'input[type="submit"]',
        'input[type="image"]',
        'label[for]',
        'select',
        'textarea',
        'button',
        '.link'
      ]}
    />
  )
}

export default AnimCursor